import type { ToolboxSectionProps } from "../../Toolbox.types";

const ToolboxSection = ({ children }: ToolboxSectionProps) => {
  return <>{children}</>;
};

export default ToolboxSection;
